const FRONTMATTER = /^---\r?\n[\s\S]*?\r?\n---\r?\n+/

export function stripFrontmatter(markdown: string): string {
  return markdown.replace(FRONTMATTER, "")
}
